export default __webpack_public_path__ + "static/media/faso_logo_cropped.17df70c9.jpg";